"use client";
import { Button } from '../ui/button';
import { Moon, Sun } from 'lucide-react';
import { useTheme } from 'next-themes';
import { useEffect, useState } from 'react';

export function ThemeToggle() {
    const { theme, setTheme } = useTheme();
    const [mounted, setMounted] = useState(false);

    useEffect(() => {
        setMounted(true);
    }, []);

    if (!mounted) {
        return (
            <Button size="icon" variant="ghost" aria-label="Toggle theme" disabled>
                <Sun className="h-5 w-5" />
            </Button>
        );
    }

    const isDark = theme === 'dark';

    return (
        <Button
            size="icon"
            variant="ghost"
            aria-label="Toggle theme"
            onClick={() => setTheme(isDark ? 'light' : 'dark')}
            className="transition-colors hover:bg-muted"
        >
            {isDark ? (
                <Sun className="h-5 w-5 transition-transform hover:rotate-12" />
            ) : (
                <Moon className="h-5 w-5 transition-transform hover:-rotate-12" />
            )}
        </Button>
    );
}
